import {h, Fragment} from "preact"
import { useFacets } from "@nosto/preact"
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import Icon from "./elements/Icon"

function ToggleSidebarButton({ className }) {
    return (
        <label
            className={`ns-act-btn ns-close-sidebar ns-absolute ns-d-block ns-text-align-right ns-align-items-center ns-clickable Drawer__Close Icon-Wrapper--clickable ${className}`}
            for="toggle-mobile-sidebar"
        >
            <svg class="Icon Icon--close " role="presentation" viewBox="0 0 16 14">
                <path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>
            </svg>
        </label>
    )
}

export default function SideBar() {
    const { loading, facets } = useFacets()

    return facets?.length > 0 ? (
        <>
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                for="toggle-mobile-sidebar"
            />
            <div
                class="ns-sidebar-wrapper CollectionFilters Drawer Drawer--secondary Drawer--fromRight ns-d-none ns-h-100"
                aria-hidden="false"
                // style={loading ? "opacity: 0.3;" : ""}
            >
                <div class="ns-sidebar-header Drawer__Header Drawer__Header--bordered Drawer__Header--center Drawer__Container">
                    <span class="Drawer__Title Heading u-h4">Filters</span>
                    <ToggleSidebarButton />
                </div>
                <div class="ns-sidebar-content ns-relative ns-background-white Drawer__Content">
                   
                    <div class="ns-sidebar-menu Drawer__Main">
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return <Facet facet={facet} />
                                    case "stats":
                                        return <RangeFacet facet={facet} />
                                    default:
                                        return null
                                }
                            })}
                        </ul>
                    </div>

                    <div class="Drawer__Footer Drawer__Footer--padded" data-drawer-animated-bottom="">
                        <div class="ButtonGroup">
                            <label class="ns-act-btn ns-close-sidebar ns-clickable ButtonGroup__Item ButtonGroup__Item--expand Button Button--primary" for="toggle-mobile-sidebar">See results</label>
                        </div>
                    </div>
                </div>
            </div>
        </>
    ) : (
        ""
    )
}
